import React, { useState } from 'react';
import Topbar from '../components/Topbar';
import { TrendingUp } from 'lucide-react';
import './TemasPage.css';

interface Tema {
  id: string;
  nome: string;
  count: number;
  cor: string;
  risco: 'low' | 'medium' | 'high';
}

const mockTemas: Tema[] = [];

export default function TemasPage() {
  const [searchTema, setSearchTema] = useState('');

  const filtered = mockTemas.filter((t) => t.nome.toLowerCase().includes(searchTema.toLowerCase()));
  const maxCount = Math.max(...mockTemas.map((t) => t.count), 1);

  return (
    <div className="temas-container">
      <Topbar title="Temas" badge="mocks" />
      <div className="temas-content">
        <div className="temas-header">
          <div>
            <h2>Temas e Assuntos</h2>
            <p className="temas-subtitle">Navegue por temas legislativos</p>
          </div>
          <input
            type="text"
            placeholder="Buscar temas..."
            value={searchTema}
            onChange={(e) => setSearchTema(e.target.value)}
            className="temas-search"
          />
        </div>

        {filtered.length > 0 ? (
          <div className="temas-grid">
            {filtered.map((tema) => {
              const percentage = (tema.count / maxCount) * 100;
              return (
                <div key={tema.id} className="tema-card" style={{ '--color': tema.cor } as React.CSSProperties}>
                  <div className="tema-header">
                    <div className="tema-nome">{tema.nome}</div>
                    <div className={`tema-risco tema-${tema.risco}`}>{tema.risco}</div>
                  </div>
                  <div className="tema-count">{tema.count} proposições</div>
                  <div className="tema-bar">
                    <div className="tema-bar-fill" style={{ width: `${percentage}%`, backgroundColor: tema.cor }} />
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="temas-empty">
            <p>Nenhum tema encontrado</p>
          </div>
        )}
      </div>
    </div>
  );
}
